export default __webpack_public_path__ + "static/CodeThemeFinder-c8bd949a9cd3b62ed97d2270a1dfab3f.jpg";